import { render, staticRenderFns } from "./sublayout.vue?vue&type=template&id=5d22878e&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22878e",
  null
  
)

export default component.exports